import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import Select from '@amzn/meridian/select';
import SelectOption, { SelectOptionProps } from '@amzn/meridian/select/select-option';
import Text from '@amzn/meridian/text';

import React from 'react';

import { SiteWebhookFormEntry, WebhookFormErrors } from '../types';

export interface WebhookRowProps {
  // index within the local component of the webhook triggering event. Used for labeling 'URL 1', 'URL 2' etc.
  urlNum: number;
  isEditing: boolean;
  accommodationTypeSelectOptions: SelectOptionProps[];
  // webhookIndex in full list of webhooks. is used for updates, clears, removals
  webhookIndex: number;
  webhook: SiteWebhookFormEntry;
  austinOnly: boolean;
  errors: WebhookFormErrors;
  updateWebhook: (webhookIndex: number, update: SiteWebhookFormEntry) => void;
  onRemove: (webhookIndex: number) => void;
}

const WebhookRow = ({
  urlNum,
  isEditing,
  accommodationTypeSelectOptions,
  webhookIndex,
  webhook,
  austinOnly,
  errors,
  updateWebhook,
  onRemove,
}: WebhookRowProps) => {
  const columnWidths = austinOnly ? ['fill', 'grid-2'] : ['fill', 'grid-3', 'grid-2'];
  return (
    <Row widths={columnWidths} spacingInset="300 none" alignmentVertical="top">
      {/* align top so errors don't throw off the field alignment */}
      <Column spacing="100">
        <Text>URL {urlNum} (Chime or Slack)</Text>
        <Input
          id={`site-webhook__url-input__event-${webhook.webhookEventId}-num-${urlNum}`}
          data-cy={`site-webhook__url-input__event-${webhook.webhookEventId}-num-${urlNum}`}
          value={webhook.webhookUrl}
          onChange={(newValue) => updateWebhook(webhookIndex, { webhookUrl: newValue })}
          type="text"
          placeholder="Url..."
          disabled={!isEditing}
          {...errors[webhookIndex]?.webhookUrl}
        />
      </Column>
      {!austinOnly && (
        <Column spacing="100">
          <Text>Receive alerts for:</Text>
          <Select
            id={`site-webhook__accommodation-type-select__event-${webhook.webhookEventId}-num-${urlNum}`}
            data-cy={`site-webhook__accommodation-type-select__event-${webhook.webhookEventId}-num-${urlNum}`}
            value={webhook.accommodationTypeId}
            onChange={(newValue) => updateWebhook(webhookIndex, { accommodationTypeId: newValue })}
            placeholder="Select..."
            disabled={!isEditing}
            {...errors[webhookIndex]?.accommodationTypeId}
          >
            {accommodationTypeSelectOptions.map((props) => (
              <SelectOption
                data-cy={`site-webhook__accommodation-type-select__dropdown-item-${props.value}`}
                {...props}
              />
            ))}
          </Select>
        </Column>
      )}
      <Column>
        {isEditing && (
          <Button type="link" onClick={() => onRemove(webhookIndex)}>
            Remove
          </Button>
        )}
      </Column>
    </Row>
  );
};

export default WebhookRow;
